import { paths } from '../libs/init/paths.mjs';
import type { Theme } from '@doxyme/ui-foundation/theme';

/** Paths that use the auth surface (fullwhite), in addition to `/auth/account/*`. */
const AUTH_FLOW_EXACT_PATHS = [
  paths.providerSelector,
  paths.postLogin,
  paths.onboarding,
  paths.workspaceSelector,
  paths.checkYourEmail,
  paths.orderSuccess,
  '/forgot-password',
  '/password-reset',
  '/reset-password',
] as const;

const normalizePath = (path: string): string => {
  const withoutQuery = path.split('?')[0] ?? path;
  const stripped = withoutQuery.replace(/\/$/, '');
  return stripped === '' ? '/' : stripped;
};

/**
 * Whether the current route is part of the sign-in / sign-up / onboarding funnel.
 * Pass `asPath` when `pathname` is a Next dynamic pattern (e.g. `[...frontegg-router]`).
 */
export const isAuthFlowPath = (pathname: string, asPath?: string): boolean => {
  const path = normalizePath(asPath ?? pathname);

  if (path.startsWith('/auth/account')) {
    return true;
  }

  if (path === paths.signIn || path.startsWith(`${paths.signIn}/`)) {
    return true;
  }

  return (AUTH_FLOW_EXACT_PATHS as readonly string[]).includes(path);
};

export const getAuthFlowBackgroundColor = (theme: Theme): string =>
  theme.background.default.fullwhite;

/** Body crossfade when leaving the auth funnel for the app shell. */
export const AUTH_TO_APP_BACKGROUND_TRANSITION_MS = 300;
